'use strict';

var moduleName = require('./src/angular-input-masks.js');

module.exports = moduleName;



//////////////////
// WEBPACK FOOTER
// ./node_modules/angular-input-masks/index.js
// module id = 1729
// module chunks = 12